import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Ensure you have react-router-dom installed
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Corousel.css';

const images = [
  {
    url: './images/tablebanner.jpg',
    caption: 'Customized Home Interiors'
  },
  {
    url: './images/banner4.jpg',
    caption: 'Energise Your Decor'
  },
  {
    url: './images/artbanner.jpg',
    caption: 'Modern Interiors Crafted with Precision'
  },
  {
    url: './images/interior2.jpg',
    caption: 'Spaces that Bring People Together'
  },
  {
    url: './images/inspiredliving.jpg',
    caption: 'Interiors for Inspired Living'
  }
];

const Corousel = () => {
  return (
    <section className="main-carousel-section">
      <motion.div
        className="carousel-wrapper glass"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Carousel
          autoPlay
          infiniteLoop
          interval={5000}
          showThumbs={false}
          showStatus={false}
          showArrows={true}
          emulateTouch
          swipeable={true}
          renderIndicator={(onClickHandler, isSelected, index, label) => (
            <li
              className={`indicator ${isSelected ? 'selected' : ''}`}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              aria-label={`${label} ${index + 1}`}
            />
          )}
        >
          {images.map((slide, index) => (
            <div className="carousel-slide" key={index}>
              <img src={slide.url} alt={`Slide ${index}`} />
              <div className="caption-wrapper">
                <motion.div
                  className="caption glass"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                >
                  <h2>{slide.caption}</h2>
                  <div className="caption-buttons">
                    <Link to="/about" className="carousel-button">About Us</Link>
                    <Link to="/contact" className="carousel-button">Contact</Link>
                  </div>
                </motion.div>
              </div>
            </div>
          ))}
        </Carousel>
      </motion.div>
    </section>
  );
};

export default Corousel;
